import React from 'react';
import { useStore } from "react-redux";
import useMedia from 'use-media';
import { TextArea } from '../../components/atoms/textArea';
import { Label } from '../atoms/label';
import { LabelInputForm } from './labelInputForm';
import { PullDownOptionForm } from './pullDownOptionForm';
import { RadioButtonForm } from './radioButtonForm';
import { ModalOptionForm } from './modalOptionForm';
import { CheckboxListBoxGold } from './checkboxListBoxGold';
import commonUtil from '../../common/commonUtil';
import { PrivilegeIcon } from '../atoms/privilegeIcon';
import { Button } from '../atoms/button';
import Const from '../../const/Const';
import messageConst from '../../const/messageConst';

export const MealInputList = (props) => {
    const { state,
        flgList,
        machiFlg,
        generalFlg,
        thanksFlg,
        mealList,
        roomList,
        inputUserInfo,
        reserveInfo,
        prefectureList,
        relationList,
        transportList,
        jikantaiKbnList,
        serviceCheckInfo,
        rightInfo,
        shokaKenriList,
        onChangeAllergyInfo,
        onChangeRelation,
        onChangeTransport,
        onChangeAgreement,
        onChangeInputForm,
        onChangeCheckBox,
        onClickRestaurant,
        onClickRiyoNinzu,
        onClickMealTime,
        onClickCourse,
        onClickDoiTitle,
        onClickServiceLink,
        onClickShuttleBusTime,
        onClickOpenPopupWindow,
        onClickSearchAddress,
        responsiveFlg,
        inputRestaurantFlg,
        confirmFlg,
        totalPrice,
        machiMongon,
        onClickOpenDescriptionHomeFlWindow,
        redFlg,
        onChangeUsedHomeFlKenriFlg,
        onChangeApplicantFlg,
        usedHomeFlKenriFlg,
        familyFlg } = props;

    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });

    const store = useStore();
    const isCrawl = store.getState().login.loginType === 'CRAWL';
    const crawlMember = store.getState().crawlMember;
    const resvKaiinken = store.getState().resvKaiinken;

    // 以下仮設定定数
    const allergyInfoList = [
        { text: "あり", value: "1", checked: false },
        { text: "なし", value: "2", checked: false },
        { text: "わからない", value: "0", checked: false }
    ];
    const telTypeList = [
        { text: "自宅", value: "1", checked: false },
        { text: "会社", value: "2", checked: false },
        { text: "携帯", value: "5", checked: false }
    ];
    const usedHomeFlKenriList = [
        { text: "優先して使用する", value: "1", checked: false },
        { text: "使用しない", value: "0", checked: false },
    ];
    // const relationList = [
    //     { value: "選択する", id: "", checked: true },
    //     { value: "本人", id: "1", checked: false },
    //     { value: "配偶者", id: "2", checked: false },
    // ];
    // const residenceList = [
    //     { value: "東京", id: "1", checked: true },
    //     { value: "大阪", id: "2", checked: false },
    // ];
    // const transportList = [
    //     { value: "電車", id: "1", checked: true },
    //     { value: "車", id: "2", checked: false },
    //     { value: "シャトルバス", id: "3", checked: false },
    // ];
    const carNumList = [
        { value: "1", id: "1", checked: true },
        { value: "2", id: "2", checked: false },
        { value: "3", id: "3", checked: false },
        { value: "4", id: "4", checked: false },
        { value: "5", id: "5", checked: false },
        { value: "6", id: "6", checked: false },
        { value: "7", id: "7", checked: false },
        { value: "8", id: "8", checked: false },
        { value: "9", id: "9", checked: false },
    ];
    const hopeCheckboxData = [
        { value: "希望する", id: true },
    ];
    const otherMailCheckbox = [
        { value: "上記アドレス以外に送付", id: true },
    ];
    const nonStopCheckIn = [
        { value: "規約に同意して希望する", id: true },
    ];
    const rightDigestion = [
        { value: "手動で選ぶ", id: true },
    ];
    const saveHomeFlInfo = [
        { value: "この設定を保存する", id: true },
    ];
    const agreement = [
        { value: "同意する", id: true }
    ];
    const machiPlanCheck = [
        { value: "上記確認しました。", id: true }
    ];
    const applicantFlgList = [
        { text: "利用する", value: true, checked: false },
        { text: "利用しない", value: false, checked: false },
    ];

    const isPrevKenrishokaYo = reserveInfo.changeFlg && shokaKenriList != null && shokaKenriList.length > 0;

    // 時間の成形処理
    const formatTime = (timeStr) => {
        // 時間にコロンを付与
        const timeWithColon = timeStr.slice(0, 2) + ":" + timeStr.slice(2);
        
        // 先頭のゼロを削除
        return timeWithColon.replace(/^0+/, '');
    }

    // const otherMenu = machiFlg != "0" || generalFlg || !otherMenuList ? null :
    //     otherMenuList.map((value, menuIndex) => <div key={"menu" + menuIndex}>
    //         {confirmFlg ?
    //             <div className="mealInputWrapper">
    //                 <div className="userInput2">
    //                     <div className={"reserveInfo"}>
    //                         <div className={"inputUserWrap"}>
    //                             <div className="confirmContentsBorder firstContent">
    //                                 <Label
    //                                     label={value.menuType == "2" ? "エステ" : "ランチ"}
    //                                     className="reserveInfoTitleNoWrap"
    //                                 />
    //                                 <div className='confirmContentsBlock'>
    //                                     <div className="confirmContents">
    //                                         <Label
    //                                             label={value.restaurantName}
    //                                             className="confirmContentLabel"
    //                                         />
    //                                     </div>
    //                                     <div className="confirmContents">
    //                                         <Label
    //                                             label={"時間"}
    //                                             className="confirmContentLabel"
    //                                         />
    //                                         <Label
    //                                             label={value.menuTime.slice(0, 2) + ":" + value.menuTime.slice(2)}
    //                                             className="confirmContentLabel"
    //                                         />
    //                                     </div>
    //                                     {value.courseList ? value.courseList.map((course, index) =>
    //                                         <div key={menuIndex + "course" + index} className="confirmContents">
    //                                             <Label
    //                                                 label={course.courseName}
    //                                                 className="confirmContentLabel"
    //                                             />
    //                                             <Label
    //                                                 label={course.courseNum + "人"}
    //                                                 className="confirmContentLabel"
    //                                             />
    //                                         </div>
    //                                     ) : null}
    //                                     {value.doiList ? value.doiList.map((doi, index) =>
    //                                         <div key={menuIndex + "doi" + index} className="confirmContents">
    //                                             <div className="confirmContentLabel">
    //                                                 <Label
    //                                                     label={doi.doiTitle}
    //                                                     className="confirmContentLabel"
    //                                                 />
    //                                                 <a href='' className="confirmContentLink">同意内容のテキストリンク</a>
    //                                             </div>
    //                                             <Label
    //                                                 label={doi.checked ? "同意する" : "同意しない"}
    //                                                 className="confirmContentLabel"
    //                                             />

    //                                         </div>
    //                                     ) : null}
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //             :
    //             <>
    //                 <div className="userInputWrapper3">
    //                     <Label
    //                         label={value.menuType == "2" ? "エステ" : "ランチ"}
    //                         className="roomIndex"
    //                     />
    //                 </div>
    //                 <div className="mealInputWrapper">
    //                     <div className="userInput2">
    //                         <div className={"stayInfo"} style={styles.userInput}>
    //                             <Label
    //                                 label={value.menuType == "2" ? "エステ" : "レストラン"}
    //                                 className="popupLabel"
    //                             />
    //                             <Label
    //                                 label={value.menuName}
    //                             />
    //                             <ModalOptionForm
    //                                 id={"menuTime"}
    //                                 divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
    //                                 labelClassName="popupLabel"
    //                                 title={"時間"}
    //                                 onClick={() => onClickOpenPopupWindow("otherMenuTime", menuIndex)}
    //                                 text={value.dispMenuTime && value.dispMenuTime != "" ? value.dispMenuTime : "選択する"}
    //                             />
    //                             <ModalOptionForm
    //                                 id={"course"}
    //                                 divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
    //                                 labelClassName="popupLabel"
    //                                 title={"コース"}
    //                                 dateClass={value.dispMenuTime != "" ? "" : "disabledClass"}
    //                                 onClick={() => onClickOpenPopupWindow("otherMenuCourse", menuIndex)}
    //                                 text={value.dispCourse && value.dispCourse != "" ? value.dispCourse : "選択する"}
    //                             />
    //                             {value.doiList ? value.doiList.map((doi, index) =>
    //                                 <div className='agreementWrapper'>
    //                                     <div className='agreementTitleWrapper'>
    //                                         <Label
    //                                             label={doi.title}
    //                                             className="agreementTitle"
    //                                         />
    //                                         <a href='value.link' className="confirmContentLink">value.title</a>
    //                                     </div>
    //                                     <CheckboxListBox
    //                                         id={"agreement" + index}
    //                                         name={"agreement"}
    //                                         data={agreement}
    //                                         wrapClassName={responsiveFlg ? "popupWrapLong" : "popupWrap"}
    //                                         labelClassName="popupLabel"
    //                                         onChange={() => console.log("agreement")}
    //                                         tabIndex=""
    //                                     />
    //                                 </div>
    //                             ) : null}
    //                         </div>
    //                     </div>
    //                 </div>
    //             </>
    //         }
    //     </div>
    //     );

    const getMeals = () => {
        const meal = [];
        mealList.map((value, mealIndex) => {
            // レストランが選択済みかの判定
            const isSelectedRestaurant = inputRestaurantFlg && value.restaurantName != "" && value.restaurantCd != "89" && value.restaurantCd != "88" && value.restaurantCd != "V0"
            meal.push(
                <div key={"meal" + mealIndex}>
                    {confirmFlg ?
                        <div className="mealInputWrapper">
                            <div className="userInput2">
                                <div className={"reserveInfo"}>
                                    <div className={"inputUserWrap"}>
                                        <div className="confirmContentsBorder firstContent">
                                            <Label
                                                label={value.nights + "日目　" + (value.jikantaiKbn == (jikantaiKbnList.find(jikantaiInfo => jikantaiInfo.jikantai == "夕") ? jikantaiKbnList.find(jikantaiInfo => jikantaiInfo.jikantai == "夕").jikantaiKbn : "2") ? "夕食" : "朝食")}
                                                className="reserveInfoTitleNoWrap"
                                            />

                                            <div className='confirmContentsBlock'>
                                                {(value.restaurantCd == "89" || value.restaurantCd == "88") ?
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={"不要"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div> :
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={value.restaurantName}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                }
                                                {value.restaurantCd != "" && value.restaurantCd != "89" && value.restaurantCd != "88" && value.restaurantCd != "V0" ?
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={"時間"}
                                                            className="confirmContentLabel"
                                                        />
                                                        <Label
                                                            label={formatTime(value.mealTime)}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                    : null
                                                }
                                                {value.courseList ? value.courseList.map((course, index) => {
                                                    if (course.courseNum !== 0) {
                                                        return (
                                                            <div key={mealIndex + "course" + index} className="confirmContents">
                                                                <Label
                                                                    label={course.courseName}
                                                                    className="confirmContentLabel"
                                                                />
                                                                <Label
                                                                    label={course.courseNum + "人"}
                                                                    className="confirmContentLabel"
                                                                />
                                                            </div>
                                                        )
                                                    }
                                                }) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <>
                            <div className="userInputWrapper3">
                                <Label
                                    label={value.nights + "日目　" + (value.jikantaiKbn == (jikantaiKbnList.find(jikantaiInfo => jikantaiInfo.jikantai == "夕") ? jikantaiKbnList.find(jikantaiInfo => jikantaiInfo.jikantai == "夕").jikantaiKbn : "2") ? "夕食" : "朝食")}
                                    className="roomIndex"
                                />
                            </div>
                            <div className="mealInputWrapper">
                                <div className="userInput2">
                                    <div className={"stayInfo"} style={styles.userInput}>
                                        <ModalOptionForm
                                            id={"restaurant"}
                                            divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                                            labelClassName="popupLabel"
                                            title={"レストラン"}
                                            dateClass={(inputRestaurantFlg ? "" : "disabledClass ") + (flgList.errorMealList && flgList.errorMealList[mealIndex].errorRestaurantCd ? "errorClass" : "")}
                                            onClick={() => inputRestaurantFlg ? onClickRestaurant(value.jikantaiKbn == (jikantaiKbnList.find(jikantaiInfo => jikantaiInfo.jikantai == "夕") ? jikantaiKbnList.find(jikantaiInfo => jikantaiInfo.jikantai == "夕").jikantaiKbn : "2") ? "dinner" : "breakfast", mealIndex) : ""}
                                            text={value.restaurantName && value.restaurantName != "" ? value.restaurantName : "選択する"}
                                        />
                                        {value.riyoNinzuFlg ?
                                            <>
                                                <ModalOptionForm
                                                    id={"riyoNinzu"}
                                                    divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                                                    labelClassName="popupLabel"
                                                    title={"利用人数"}
                                                    dateClass={(isSelectedRestaurant ? "" : "disabledClass ") + (flgList.errorMealList && flgList.errorMealList[mealIndex].errorRiyoNinzu ? "errorClass" : "")}
                                                    onClick={() => isSelectedRestaurant ? onClickRiyoNinzu("riyoNinzu", mealIndex) : ""}
                                                    text={isSelectedRestaurant && value.riyoNinzu && value.riyoNinzu != "" ? value.riyoNinzu + "人" : "選択する"}
                                                />
                                                <ModalOptionForm
                                                    id={"mealTime"}
                                                    divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                                                    labelClassName="popupLabel"
                                                    title={"時間"}
                                                    dateClass={(isSelectedRestaurant && value.riyoNinzu != "" ? "" : "disabledClass ") + (flgList.errorMealList && flgList.errorMealList[mealIndex].errorMealTime ? "errorClass" : "")}
                                                    onClick={() => isSelectedRestaurant && value.riyoNinzu != "" ? onClickMealTime("mealTime", mealIndex) : ""}
                                                    text={value.mealTime && value.mealTime != "" ? formatTime(value.mealTime) : "選択する"}
                                                />
                                            </>
                                            :
                                            <ModalOptionForm
                                                id={"mealTime"}
                                                divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                                                labelClassName="popupLabel"
                                                title={"時間"}
                                                dateClass={(isSelectedRestaurant ? "" : "disabledClass ") + (flgList.errorMealList && flgList.errorMealList[mealIndex].errorMealTime ? "errorClass" : "")}
                                                onClick={() => isSelectedRestaurant ? onClickMealTime("mealTime", mealIndex) : ""}
                                                text={value.mealTime && value.mealTime != "" ? formatTime(value.mealTime) : "選択する"}
                                            />
                                        }
                                        <ModalOptionForm
                                            id={"course"}
                                            divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                                            labelClassName="popupLabel"
                                            title={"コース"}
                                            dateClass={(inputRestaurantFlg && value.mealTime != "" && value.mealTime != null ? "" : "disabledClass ") + (flgList.errorMealList && flgList.errorMealList[mealIndex].errorCourse ? "errorClass" : "")}
                                            onClick={() => inputRestaurantFlg && value.mealTime != "" && value.mealTime != null ? onClickCourse("course", mealIndex) : ""}
                                            text={value.dispCourse != "" ? value.dispCourse : "選択する"}
                                        />
                                        {value.doiList ? value.doiList.map((doiInfo, index) =>
                                            <div key={mealIndex + "doi" + index} className={'agreementWrapper ' + (flgList.errorMealList && flgList.errorMealList[mealIndex].errorDoi[index] ? "errorClassCheck" : "")}>
                                                <div className='agreementTitleWrapper'>
                                                    <a className="confirmContentLink" onClick={() => onClickDoiTitle(mealIndex, index)}>{doiInfo.doiTitle}</a>
                                                </div>
                                                <CheckboxListBoxGold
                                                    id={"agreement" + mealIndex + "_" + index}
                                                    name={"agreement" + mealIndex + "_" + index}

                                                    data={[{ ...agreement[0], checked: doiInfo.checked }]}
                                                    onChange={() => onChangeAgreement(mealIndex, index)}
                                                    tabIndex=""
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            );
        })
        return meal;
    }
    const meals = machiFlg != "0" || generalFlg ? null : getMeals();

    // 素泊まりプランまたは待ち予約の場合は料金欄を表示しない
    const isDisplayPriceArea = (reserveInfo.breakfastTsukiPlanFlg || reserveInfo.dinnerTsukiPlanFlg || thanksFlg
        || totalPrice?.planCategoryDetailCd == Const.TRAVEL_SUPPORT_CODE || Const.DISP_PRICE_CODE.includes(totalPrice?.planCategoryDetailCd)) && machiFlg === "0";

    const userInfo = <div >
        {confirmFlg ?
            <>
                <div className="reserveInputWrapper lastContent">
                    <div className="userInput2">
                        <div className={"reserveInfo"}>
                            <div className={"inputUserWrap"}>
                                <div className='confirmContentsBlock'>
                                    {machiFlg != 0 ?
                                        <div className="confirmContentsBorder lastContent">
                                            <Label
                                                label="食事希望欄"
                                                className="reserveInfoTitleNoWrap"
                                            />
                                            <Label
                                                label={inputUserInfo.foodRequest ? inputUserInfo.foodRequest : "　"}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                        : null}
                                    <div className="confirmContentsBorder lastContent">
                                        <Label
                                            label={"アレルギー"}
                                            className="reserveInfoTitleNoWrap"
                                        />
                                        <div className='confirmContentsBlock'>
                                            <div className="confirmContents">
                                                <Label
                                                    label={inputUserInfo.allergyKbn == "1" ? "あり" : inputUserInfo.allergyKbn == "2" ? "なし" : "わからない"}
                                                    className="confirmContentLabel"
                                                />
                                            </div>
                                            <div className={inputUserInfo.allergyBiko ? "confirmContents" : "hiddenItem"}>
                                                <Label
                                                    label={"アレルギー内容"}
                                                    className="confirmContentLabelGray"
                                                />
                                                <Label
                                                    label={inputUserInfo.allergyBiko}
                                                    className="confirmContentLabel"
                                                />
                                            </div>
                                            <div >
                                                {machiFlg != 0 ?
                                                    null
                                                    :
                                                    <div className={inputUserInfo.foodRequest ? "confirmContents" : "hiddenItem"}>
                                                        <Label
                                                            label="食事要望"
                                                            className="confirmContentLabelGray"
                                                        />
                                                        <Label
                                                            label={inputUserInfo.foodRequest}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="reserveInputWrapper" style={isDisplayPriceArea ? {} : styles.pricePadding}>
                    <div className="reserveInfo" style={isDisplayPriceArea ? {} : styles.priceArea}>
                        <div className={"inputUserWrap"}>
                            <div className="confirmPrice">
                                <Label
                                    label={"プラン料金"}
                                    className="reserveInfoTitleNoWrap"
                                />
                                <div className='confirmContentsBlock'>
                                    {totalPrice.targetList.map((target, index) =>
                                        <>
                                            <Label
                                                label={target.stayNum + "日目"}
                                                className="reserveInfoTitle"
                                            />
                                            {target.roomPriceListTotal.map(roomPriceTotal =>
                                                <>
                                                    <div>
                                                        <Label
                                                            label={roomPriceTotal.roomSeq + "部屋目"}
                                                            className="confirmContentLabel"
                                                        />
                                                        {roomPriceTotal.roomPriceList.map(roomPrice =>
                                                            <Label
                                                                label={roomPrice.target + ": ￥" + roomPrice.price.toLocaleString() + " × " + roomPrice.cnt + "名 = ￥" + (roomPrice.price * roomPrice.cnt).toLocaleString()}
                                                                className="confirmContentLabel"
                                                            />
                                                        )}
                                                    </div>
                                                    <br />
                                                </>
                                            )}
                                        </>
                                    )}
                                    <div className='priceContentLabel'>
                                        {totalPrice.roomPriceListType ? totalPrice.roomPriceListType.map(roomPriceType =>
                                            <>
                                                <Label
                                                    label={roomPriceType.roomSeq + "部屋目: ￥" + roomPriceType.priceRoom.toLocaleString()}
                                                    className="roomNumTitle"
                                                />
                                                <br />
                                            </>
                                        )
                                            : null}
                                    </div>
                                    {/* <div>
                                        {totalPrice.totalFoodPrice && totalPrice.totalFoodPrice > 0 ?
                                            <>
                                                <Label
                                                    label={"食事料金: ￥" + totalPrice.totalFoodPrice.toLocaleString()}
                                                    className="confirmContentLabel"
                                                />
                                                <br />
                                            </>
                                            : null}
                                    </div> */}
                                    <div className='confirmContents lastContent'>
                                        <div className='priceContentLabel'>
                                            <Label
                                                label={"(サービス料・消費税含む)"}
                                                className="priceLabel"
                                            />
                                            <Label
                                                label={"合計：￥" + totalPrice.totalRoomPrice?.toLocaleString()}
                                                className="priceLabel"
                                            />
                                            {totalPrice?.planCategoryDetailCd == Const.TRAVEL_SUPPORT_CODE ?
                                                <>
                                                    {totalPrice.totalDiscountPrice ?
                                                        <>
                                                            <Label
                                                                label={"全国旅行支援：￥-" + totalPrice.totalDiscountPrice?.toLocaleString()}
                                                                className={"priceLabel"}
                                                            />
                                                            <Label
                                                                label={"お支払い額：￥" + (totalPrice.totalRoomPrice - (totalPrice.totalDiscountPrice ? totalPrice.totalDiscountPrice : 0))?.toLocaleString()}
                                                                className="priceLabel redChar"
                                                            />
                                                        </>
                                                        :
                                                        null
                                                    }
                                                    {totalPrice.totalCouponPrice ?
                                                        <>
                                                            <Label
                                                                label={"割引対象者数：" + totalPrice.discountNum + "人"}
                                                                className="priceLabel"
                                                            />
                                                            <Label
                                                                label={"地域クーポン：￥" + totalPrice.totalCouponPrice?.toLocaleString()}
                                                                className="priceLabel"
                                                            />
                                                        </>
                                                        :
                                                        null
                                                    }
                                                </>
                                                :
                                                null
                                            }
                                            <div className={responsiveFlg ? "priceContentLabel str_padding" : "hiddenItem"}>
                                                {totalPrice?.planCategoryDetailCd == Const.TRAVEL_SUPPORT_CODE && !totalPrice.totalDiscountPrice ?
                                                    <Label
                                                        label="全国旅行支援対象外"
                                                        className="redChar"
                                                    />
                                                    :
                                                    null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                        <div className={responsiveFlg ? "hiddenItem" : 'priceContentLabel str_padding'}>{totalPrice?.planCategoryDetailCd == Const.TRAVEL_SUPPORT_CODE && !totalPrice.totalDiscountPrice ?
                                            <div>
                                                <Label
                                                    label="全国旅行支援対象外"
                                                    className="redChar"
                                                />
                                            </div>
                                            :
                                            null
                                        }</div>
                                    <Label
                                        label={messageConst.PRICE_COMMENT}
                                        className="priceComment redChar"
                                    />
                                    <Label
                                        label={messageConst.TAX_COMMENT}
                                        className="priceComment"
                                    />
                                    {totalPrice?.planCategoryDetailCd == Const.TRAVEL_SUPPORT_CODE ?
                                        <>
                                            <Label
                                                label={messageConst.TRAVEL_SUPPORT_TARGET_COMMENT}
                                                className="priceComment redChar"
                                            />
                                            <Label
                                                label={messageConst.TRAVEL_SUPPORT_COMMENT}
                                                className="priceComment redChar"
                                            />
                                            {Const.SHISETSU_CODE_TOBA.includes(reserveInfo.shisetsuCd) || Const.SHISETSU_CODE_NARUTO.includes(reserveInfo.shisetsuCd) ?
                                                <Label
                                                    label={messageConst.TRAVEL_SUPPORT_PRICE_COMMENT}
                                                    className="priceComment redChar"
                                                />
                                                :
                                                null
                                            }
                                            {totalPrice?.holidayFlg ?
                                                <Label
                                                    label={messageConst.TRAVEL_SUPPORT_HOLIDAY_COMMENT}
                                                    className="priceComment redChar"
                                                />
                                                :
                                                null
                                            }
                                        </>
                                        :
                                        null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="reserveInputWrapper lastContent" style={styles.topGrayBorder}>
                    <div className="userInput2">
                        <div className={"reserveInfo"}>
                            <div className={"inputUserWrap"}>
                                {!isCrawl && !generalFlg ?
                                    <div className="confirmContentsBorder">
                                        <Label
                                            label="予約者ご本人様"
                                            className="reserveInfoTitleNoWrap"
                                        />
                                        <div className='confirmContentsBlock'>
                                            <div className="confirmContents">
                                                <Label
                                                    label={applicantFlgList.find(value => value.value == inputUserInfo.applicantFlg).text ?? "利用しない"}
                                                    className="confirmContentLabel"
                                                />
                                            </div>
                                        </div>
                                    </div> : null
                                }
                                <div className="confirmContentsBorder">
                                    <Label
                                        label={"利用代表者"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        <div className="confirmContents">
                                            <Label
                                                label={"氏名（カナ）"}
                                                className="confirmContentLabelGray"
                                            />
                                            <Label
                                                label={inputUserInfo.daihyouNameKana}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                        <div className="confirmContents">
                                            <Label
                                                label={"氏名（漢字）"}
                                                className="confirmContentLabelGray"
                                            />
                                            <Label
                                                label={inputUserInfo.daihyouName}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="confirmContentsBorder">
                                    <Label
                                        label={"利用代表者電話番号"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        <div className="confirmContents">
                                            {!generalFlg && (
                                                <Label
                                                    label={inputUserInfo.mainPhoneKbn == "1" ? "自宅" : inputUserInfo.mainPhoneKbn == "2" ? "会社" : "携帯"}
                                                    className="confirmContentLabelGray"
                                                />
                                            )}
                                            <Label
                                                label={inputUserInfo.mainPhoneNumber}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {!generalFlg && (
                                    <div className="confirmContentsBorder">
                                        <Label
                                            label={"予約連絡先電話番号"}
                                            className="reserveInfoTitleNoWrap"
                                        />
                                        <div className='confirmContentsBlock'>
                                            <div className="confirmContents">
                                                <Label
                                                    label={inputUserInfo.contactPhoneNumber}
                                                    className="confirmContentLabel"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="confirmContentsBorder">
                                    <Label
                                        label={"予約連絡先メールアドレス"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        <div className="confirmContents">
                                            <Label
                                                label={inputUserInfo.contactMailAddress}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {generalFlg ?
                                    <>
                                        <div className="confirmContentsBorder">
                                            <Label
                                                label={"住所"}
                                                className="reserveInfoTitleNoWrap"
                                            />
                                            <div className='confirmContentsBlock'>
                                                <div className="confirmContents">
                                                    <Label
                                                        label={
                                                            '〒'
                                                            + inputUserInfo.zipCode1
                                                            + '-'
                                                            + inputUserInfo.zipCode2
                                                            + ' '
                                                            + inputUserInfo.prefecture
                                                            + inputUserInfo.address1
                                                            + inputUserInfo.address2
                                                            + inputUserInfo.address3
                                                        }
                                                        className="confirmContentLabel"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="confirmContentsBorder">
                                            <Label
                                                label={"会員様とのご関係"}
                                                className="reserveInfoTitleNoWrap"
                                            />
                                            <div className='confirmContentsBlock'>
                                                <div className="confirmContents">
                                                    <Label
                                                        label={inputUserInfo.relation}
                                                        className="confirmContentLabel"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="confirmContentsBorder">
                                            <Label
                                                label={"利用代表者の居住地"}
                                                className="reserveInfoTitleNoWrap"
                                            />
                                            <div className='confirmContentsBlock'>
                                                <div className="confirmContents">
                                                    <Label
                                                        label={inputUserInfo.prefecture}
                                                        className="confirmContentLabel"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="confirmContentsBorder">
                                            <Label
                                                label={"交通機関"}
                                                className="reserveInfoTitleNoWrap"
                                            />
                                            <div className='confirmContentsBlock'>
                                                <div className="confirmContents">
                                                    <Label
                                                        label={inputUserInfo.transport}
                                                        className="confirmContentLabel"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {inputUserInfo.transportCd != 2 ? null :
                                            <div className="confirmContentsBorder">
                                                <Label
                                                    label={"車の場合"}
                                                    className="reserveInfoTitleNoWrap"
                                                />
                                                <div className='confirmContentsBlock'>
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={inputUserInfo.carCnt + "台"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {/* <div className="confirmContentsBorder">
                                            <Label
                                                label={"シャトルバス時間"}
                                                className="reserveInfoTitleNoWrap"
                                            />
                                            <div className='confirmContentsBlock'>
                                                <div className="confirmContents">
                                                    <Label
                                                        label={inputUserInfo.busTime ? inputUserInfo.busTime.slice(0, 2) + ":" + inputUserInfo.busTime.slice(2) : ""}
                                                        className="confirmContentLabel"
                                                    />
                                                </div>
                                            </div>
                                        </div> */}
                                        {inputUserInfo.kozafurikaeDispFlg ?
                                            <div className="confirmContentsBorder">
                                                <Label
                                                    label={"口座振替精算"}
                                                    className="reserveInfoTitleNoWrap"
                                                />
                                                <div className='confirmContentsBlock'>
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={inputUserInfo.kozafurikaeFlg && hopeCheckboxData.find(value => value.id == inputUserInfo.kozafurikaeFlg) ? hopeCheckboxData.find(value => value.id == inputUserInfo.kozafurikaeFlg).value : "希望しない"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                        }
                                        {inputUserInfo.smartCheckInDispFlg ?
                                            <div className="confirmContentsBorder">
                                                <Label
                                                    label={"スマートチェックイン"}
                                                    className="reserveInfoTitleNoWrap"
                                                />
                                                <div className='confirmContentsBlock'>
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={inputUserInfo.smartCheckInFlg && hopeCheckboxData.find(value => value.id == inputUserInfo.smartCheckInFlg) ? hopeCheckboxData.find(value => value.id == inputUserInfo.smartCheckInFlg).value : "希望しない"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                        }
                                        {inputUserInfo.smartCheckOutDispFlg ?
                                            <div className="confirmContentsBorder">
                                                <Label
                                                    label={"スマートチェックアウト"}
                                                    className="reserveInfoTitleNoWrap"
                                                />
                                                <div className='confirmContentsBlock'>
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={inputUserInfo.smartCheckOutFlg && hopeCheckboxData.find(value => value.id == inputUserInfo.smartCheckOutFlg) ? hopeCheckboxData.find(value => value.id == inputUserInfo.smartCheckOutFlg).value : "希望しない"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                        }
                                        {inputUserInfo.nonstopCheckInDispFlg ?
                                            <div className="confirmContentsBorder">
                                                <Label
                                                    label={"ノンストップチェックイン"}
                                                    className="reserveInfoTitleNoWrap"
                                                />
                                                <div className='confirmContentsBlock'>
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={inputUserInfo.nonstopCheckInFlg && hopeCheckboxData.find(value => value.id == inputUserInfo.nonstopCheckInFlg) ? hopeCheckboxData.find(value => value.id == inputUserInfo.nonstopCheckInFlg).value : "希望しない"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                        }
                                    </>
                                }
                                <div className="confirmContentsBorder">
                                    <Label
                                        label={"その他要望"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        <div className="confirmContents">
                                            <Label
                                                label={inputUserInfo.biko ? inputUserInfo.biko : "　"}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {rightInfo && rightInfo.length != 0 ? rightInfo.map((value, index) =>
                                    <div key={"right" + index} className="confirmContentsBorder">
                                        <Label
                                            label={index == 0 ? "権利消化" : ""}
                                            className="reserveInfoTitleNoWrap"
                                        />
                                        <div className='confirmContentsBlock'>
                                            <Label
                                                label={value.stayNum + "泊目"}
                                                className="confirmContentLabelGray"
                                            />
                                            <div className='confirmContents'>
                                                <PrivilegeIcon className={value.senyuKenriIro} />
                                                <Label
                                                    label={commonUtil.getStringFromDateJpnMembership(value.siyoDate)}
                                                    className="confirmContentLabel"
                                                />
                                            </div>
                                            <Label
                                                label={"消化権利"}
                                                className="confirmContentLabelGray"
                                            />
                                            <div style={{ marginBottom: "20px", alignItems: "center", height: "auto" }}>
                                                {
                                                    value.senyuDate.map(useDate =>
                                                        useDate.senyuDatHyojiOkFlg ?
                                                        <div style={{ display: "flex", marginBottom: "10px", alignItems: "center", }}>
                                                            <PrivilegeIcon className={useDate.shokaKenriIro} />
                                                            <Label
                                                                label={commonUtil.getStringFromDateJpnMembership(useDate.shokaKenriDate)}
                                                                className="confirmContentLabel"
                                                            />
                                                        </div>
                                                        :
                                                        <div style={{ display: "flex", marginBottom: "10px", alignItems: "center", }}>
                                                            <PrivilegeIcon className={useDate.shokaKenriIro} />
                                                            <Label
                                                                label={useDate.senyuDatHyojiDaitaiStr}
                                                                className="confirmContentLabel"
                                                            />
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>

                                    </div>
                                ) : null}
                                {!generalFlg && (
                                    <div className="confirmContentsBorder">
                                        <Label
                                            label={"予約確認メール"}
                                            className="reserveInfoTitleNoWrap"
                                        />
                                        <div className='confirmContentsBlock'>
                                            {responsiveFlg ?
                                                <>
                                                    <div className="confirmContentsBlock">
                                                        <Label
                                                            label={inputUserInfo.kakuninMailKiboKbn != 0 && inputUserInfo.kakuninMailKiboKbn && hopeCheckboxData.find(value => value.id == inputUserInfo.kakuninMailKiboKbn) ? hopeCheckboxData.find(value => value.id == inputUserInfo.kakuninMailKiboKbn).value : "希望しない"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                    <div className={inputUserInfo.kakuninMailKiboKbn != 0 && inputUserInfo.kakuninMailKiboKbn ? "confirmContentsBlock contentMarginBottom" : "hiddenItem"}>
                                                        <Label
                                                            label="予約確認用メールアドレス"
                                                            className="confirmContentLabelGray"
                                                        />
                                                        <Label
                                                            label={inputUserInfo.confirmReserveMail}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                </>
                                                :
                                                <div className="confirmContents">
                                                    <Label
                                                        label={inputUserInfo.kakuninMailKiboKbn != 0 && inputUserInfo.kakuninMailKiboKbn && hopeCheckboxData.find(value => value.id == inputUserInfo.kakuninMailKiboKbn) ? hopeCheckboxData.find(value => value.id == inputUserInfo.kakuninMailKiboKbn).value : "希望しない"}
                                                        className="confirmContentLabel"
                                                    />
                                                    <Label
                                                        label={inputUserInfo ? inputUserInfo.confirmReserveMail : ""}
                                                        className={inputUserInfo.kakuninMailKiboKbn != 0 && inputUserInfo.kakuninMailKiboKbn ? "confirmContentLabel" : "hiddenItem"}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                )}
                                {inputUserInfo?.machiPlanCheckDispFlg ?
                                    <div className="confirmContentsBlock">
                                        <Label
                                            label={inputUserInfo.machiMongon}
                                            className="machiPlanCheckLabel"
                                        />
                                        <Label
                                            label={"上記確認しました。"}
                                            className="confirmContentLabel"
                                        />
                                    </div>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
            :
            <div className="representInputWrapper lastContent">
                <div style={{ paddingBottom: "30px" }}>
                    {generalFlg ? null
                        :
                        <>
                            {machiFlg != 0 ?
                                <>
                                    <Label
                                        label="食事希望欄"
                                        className="representInfoLabel"
                                    />
                                    <TextArea
                                        id="foodRequest"
                                        value={inputUserInfo.foodRequest}
                                        onBlur={() => onChangeInputForm("foodRequest")}
                                        style={flgList.errorFoodRequest ? styles.foodRequestError : styles.foodRequest}
                                        maxLength={"666"}
                                    />
                                </>
                                : null}
                            <div className="representInfoLabel">
                            <Label
                                label={"アレルギー"}
                            />
                            <div style={{ display: "flex"}}>
                                <Label
                                    label={"食物アレルギー対応基本方針は"}
                                    className="annotationMessage2"
                                />
                                <a href="https://www.resorttrust.co.jp/corporate/allergy/" className="annotationLink" target="_blank" rel="noopener noreferrer">こちら</a>
                            </div>
                            </div>
                            <RadioButtonForm
                                data={inputUserInfo ?
                                    allergyInfoList.map((allergyInfo) => {
                                        if (allergyInfo.value == inputUserInfo.allergyKbn) {
                                            allergyInfo.checked = true;
                                        } else {
                                            allergyInfo.checked = false;
                                        }
                                        return allergyInfo;
                                    })
                                    : allergyInfoList}
                                labelClassName={"inputRadioLabel"}
                                inputClassName="inputRadioButtonGold"
                                wrapClassName={flgList.errorAllergyExistence ? "errorClassCheck" : ""}
                                id="allergyExistence"
                                name="allergyExistence"
                                style={{ display: "flex", marginTop: "10px", marginBottom: "20px" }}
                                onChange={onChangeAllergyInfo}
                            />
                            <div className={"stayInfo"} style={styles.userInput}>
                                <LabelInputForm
                                    label={"アレルギー内容"}
                                    id="allergyBiko"
                                    disabled={!inputUserInfo.allergyKbn || inputUserInfo.allergyKbn != "1"}
                                    value={inputUserInfo ? inputUserInfo.allergyBiko : ""}
                                    onChange={() => onChangeInputForm("allergyBiko")}
                                    className={flgList.errorAllergyBiko ? "inputKeywordError" : "inputKeyword"}
                                    labelClassName="popupLabel"
                                    wrapClassName="popupWrapLong"
                                    maxLength={"666"}
                                />
                                <Label
                                    label={messageConst.ALLERGY_SAMPLE_MESSAGE}
                                    className="annotationMessage"
                                />
                                {machiFlg != 0 ?
                                    null
                                    :
                                    <>
                                        <Label
                                            label="食事要望"
                                            className="popupLabel"
                                        />
                                        <TextArea
                                            id="foodRequest"
                                            style={flgList.errorFoodRequest ? styles.foodRequestError : styles.foodRequest}
                                            onBlur={() => onChangeInputForm("foodRequest")}
                                            value={inputUserInfo ? inputUserInfo.foodRequest : ""}
                                            maxLength={"666"}
                                        />
                                    </>
                                }
                            </div>
                        </>}
                    <Label
                        label={"利用代表者"}
                        className="representInfoLabel"
                    />
                    {!isCrawl && !generalFlg ?
                        <div class="applicant-flg-wrapper">
                            <Label
                                label="予約者ご本人様"
                                className="popupLabel"
                            />
                                <RadioButtonForm
                                        labelClassName="inputRadioLabel"
                                        inputClassName="inputRadioButtonGold"
                                        wrapClassName={flgList.errorApplicantFlg ? "errorClassCheck" : ""}
                                        data={
                                            inputUserInfo && inputUserInfo.applicantFlg !== null
                                                ? applicantFlgList.map((applicantFlgInfo) => {
                                                    if (applicantFlgInfo.value == inputUserInfo.applicantFlg) {
                                                        applicantFlgInfo.checked = true;
                                                    } else {
                                                        applicantFlgInfo.checked = false;
                                                    }
                                                    return {
                                                        text: applicantFlgInfo.text,
                                                        value: applicantFlgInfo.value,
                                                        checked: applicantFlgInfo.checked,
                                                    };
                                                })
                                                : applicantFlgList
                                        }
                                        id="applicantFlg"
                                        name="applicantFlg"
                                        onChange={() => {onChangeApplicantFlg();}}
                                        style={{
                                            display: "flex",
                                            marginTop: "10px",
                                            marginBottom: "5px",
                                        }}
                                    />
                        </div>
                        : null
                    }
                    <LabelInputForm
                        label="氏名（カナ）"
                        type={"id"}
                        id="daihyouNameKana"
                        placeholder="ヤマダ イチロウ"
                        className={`${(flgList.errorRepresentName ? "inputKeywordError" : "inputKeyword")} ${(inputUserInfo.applicantFlg ? "disabledClass" : "")}`}
                        value={inputUserInfo ? inputUserInfo.daihyouNameKana : ""}
                        onChange={() => onChangeInputForm("daihyouNameKana")}
                        labelClassName="popupLabel"
                        wrapClassName="userInputTextWrap3"
                        maxLength={"35"}
                        disabled={inputUserInfo.applicantFlg}
                    />
                    <LabelInputForm
                        label={"氏名（漢字）"}
                        id="daihyouName"
                        placeholder="山田 一郎"
                        className={`${(flgList.errorRepresentName ? "inputKeywordError" : "inputKeyword")} ${(inputUserInfo.applicantFlg ? "disabledClass" : "")}`}
                        value={inputUserInfo ? inputUserInfo.daihyouName : ""}
                        onChange={() => onChangeInputForm("daihyouName")}
                        labelClassName="popupLabel"
                        wrapClassName="userInputTextWrap3"
                        maxLength={"35"}
                        disabled={inputUserInfo.applicantFlg}
                    />
                    {!generalFlg && (
                        <>
                            <Label
                                label="利用代表者電話番号"
                                className="popupLabel"
                                style={{ marginTop: "20px" }}
                            />
                            <RadioButtonForm
                                labelClassName="inputRadioLabel"
                                inputClassName="inputRadioButtonGold"
                                wrapClassName={flgList.errorRepresentTelKbn ? "errorClassCheck" : ""}
                                data={
                                    inputUserInfo && inputUserInfo.mainPhoneKbn
                                        ? telTypeList.map((telTypeInfo) => {
                                            if (telTypeInfo.value == inputUserInfo.mainPhoneKbn) {
                                                telTypeInfo.checked = true;
                                            } else {
                                                telTypeInfo.checked = false;
                                            }
                                            return {
                                                text: telTypeInfo.text,
                                                value: telTypeInfo.value,
                                                checked: telTypeInfo.checked,
                                            };
                                        })
                                        : telTypeList
                                }
                                id="mainPhoneKbn"
                                name="mainPhoneKbn"
                                onChange={() => console.log("mainPhoneKbn")}
                                style={{
                                    display: "flex",
                                    marginTop: "10px",
                                    marginBottom: "20px",
                                }}
                            />
                        </>
                    )}
                    {generalFlg ? (
                        <LabelInputForm
                            label="利用代表者電話番号"
                            id="mainPhoneNumber"
                            placeholder="012-345-6789"
                            className={
                                flgList.errorRepresentTelNumber
                                    ? "inputKeywordError"
                                    : "inputKeyword"
                            }
                            value={inputUserInfo ? inputUserInfo.mainPhoneNumber : ""}
                            onChange={() => onChangeInputForm("mainPhoneNumber")}
                            labelClassName="popupLabel"
                            wrapClassName="userInputTextWrap3"
                            maxLength={"15"}
                        />
                    ) : (
                        <LabelInputForm
                            id="mainPhoneNumber"
                            placeholder="012-345-6789"
                            className={
                                flgList.errorRepresentTelNumber
                                    ? "inputKeywordError"
                                    : "inputKeyword"
                            }
                            value={inputUserInfo ? inputUserInfo.mainPhoneNumber : ""}
                            onChange={() => onChangeInputForm("mainPhoneNumber")}
                            maxLength={"15"}
                        />
                    )}
                    {!generalFlg && (
                        <LabelInputForm
                            label="予約連絡先電話番号"
                            id="contactPhoneNumber"
                            placeholder="012-345-6789"
                            className={flgList.errorReserverTelNumber ? "inputKeywordError" : "inputKeyword"}
                            value={inputUserInfo ? inputUserInfo.contactPhoneNumber : ""}
                            onChange={() => onChangeInputForm("contactPhoneNumber")}
                            labelClassName="popupLabel"
                            wrapClassName="userInputTextWrap3"
                            maxLength={"15"}
                        />
                    )}
                    <LabelInputForm
                        label={"予約連絡先メールアドレス"}
                        id="contactMailAddress"
                        placeholder="rtg@trast.jp"
                        className={`${flgList.errorReserverMail ? "inputKeywordError" : "inputKeyword"} ${isCrawl ? " disabledClass" : ""}`}
                        value={isCrawl ? crawlMember.mail_adr : inputUserInfo ? inputUserInfo.contactMailAddress : ""}
                        onChange={() => onChangeInputForm("contactMailAddress")}
                        labelClassName="popupLabel"
                        wrapClassName="userInputTextWrap3"
                        disabled={isCrawl}
                        maxLength={"50"}
                    />
                    <Label
                        label="※弊社ドメイン「@resorttrust.co.jp」「@rt-group.jp」からのメールが受信できるよう設定確認をお願いします。"
                        className="annotationMessage"
                    />
                    {generalFlg ?
                        <>
                            <Label
                                label={"住所"}
                                className="popupLabel"
                            />
                            <div className='inputZipCode'>
                                <LabelInputForm
                                    id="zipCode1"
                                    maxLength={"3"}
                                    placeholder="123"
                                    className={flgList.errorZipCode ? "inputKeywordError" : "inputKeyword"}
                                    value={inputUserInfo ? inputUserInfo.zipCode1 : ""}
                                    onChange={() => onChangeInputForm("zipCode1")}
                                    labelClassName="popupLabel"
                                    wrapClassName="userInputTextWrap2"
                                />
                                <Label
                                    label={"ー"}
                                    className="inputHunmanNumLabel"
                                />
                                <LabelInputForm
                                    id="zipCode2"
                                    maxLength={"4"}
                                    placeholder="4567"
                                    className={flgList.errorZipCode ? "inputKeywordError" : "inputKeyword"}
                                    value={inputUserInfo ? inputUserInfo.zipCode2 : ""}
                                    onChange={() => onChangeInputForm("zipCode2")}
                                    labelClassName="popupLabel"
                                    wrapClassName="userInputTextWrap2"
                                />
                                <Button buttonText="検索" className="btnToConfirm" onClick={() => onClickSearchAddress()} buttonClassName="serachBtnText" />
                            </div>
                            <PullDownOptionForm
                                id="prefectureCd"
                                divClass="inputUserPullDownWrapLong"
                                labelClassName="popupLabel"
                                selectClass={"pullDownOptionStyle " + (flgList.errorPrefecture ? "errorClass" : "")}
                                data={prefectureList}
                                onChange={() => onChangeInputForm("prefectureCd")}
                                state={inputUserInfo ? inputUserInfo.prefectureCd : ""}
                            />
                            <LabelInputForm
                                id="address1"
                                placeholder="市区群を入力（全角）"
                                className={flgList.errorAddress1 ? "inputKeywordError" : "inputKeyword"}
                                value={inputUserInfo.address1 ? inputUserInfo.address1 : ""}
                                onChange={() => onChangeInputForm("address1")}
                                labelClassName="popupLabel"
                                wrapClassName="userInputTextWrap3"
                            />
                            <LabelInputForm
                                id="address2"
                                placeholder="町名、番地を入力（全角）"
                                className={flgList.errorAddress2 ? "inputKeywordError" : "inputKeyword"}
                                value={inputUserInfo.address2 ? inputUserInfo.address2 : ""}
                                onChange={() => onChangeInputForm("address2")}
                                labelClassName="popupLabel"
                                wrapClassName="userInputTextWrap3"
                            />
                            <LabelInputForm
                                id="address3"
                                placeholder="ビル、マンション名を入力（全角）"
                                className={flgList.errorAddress3 ? "inputKeywordError" : "inputKeyword"}
                                value={inputUserInfo.address3 ? inputUserInfo.address3 : ""}
                                onChange={() => onChangeInputForm("address3")}
                                labelClassName="popupLabel"
                                wrapClassName="userInputTextWrap3"
                            />
                            <PullDownOptionForm
                                title={"交通機関"}
                                id="transport"
                                divClass="inputUserPullDownWrapLong"
                                labelClassName="popupLabel"
                                selectClass={"pullDownOptionStyle " + (flgList.errorTransport ? "errorClass" : "")}
                                data={transportList}
                                onChange={() => onChangeTransport()}
                                state={inputUserInfo ? inputUserInfo.transportCd : ""}
                            />
                            {inputUserInfo.transportCd != 2 ? null :
                                <div className='carNumForm'>
                                    <PullDownOptionForm
                                        title={"車の台数"}
                                        id="carCnt"
                                        divClass="inputUserPullDownWrapShort"
                                        labelClassName="popupLabel"
                                        selectClass={flgList.errorCarNum ? "errorPullDownOptionStyle" : "pullDownOptionStyle"}
                                        data={carNumList}
                                        onChange={() => onChangeInputForm("carCnt")}
                                        state={inputUserInfo ? inputUserInfo.carCnt : ""}
                                    />
                                    <div >
                                        <Label
                                            label="台"
                                            style={{ marginLeft: "10px" }}
                                        />
                                    </div>
                                </div>
                            }
                            {/* {inputUserInfo.transport != 3 ? null :
                                <ModalOptionForm
                                    id={"busTime"}
                                    wrapClassName={responsiveFlg ? "popupWrapLong" : "popupWrap"}
                                    labelClassName="popupLabel"
                                    title={"シャトルバス時間"}
                                    onClick={() => onClickShuttleBusTime("busTime")}
                                    text={inputUserInfo.busTime ? inputUserInfo.busTime.slice(0, 2) + ":" + inputUserInfo.busTime.slice(2) : "選択する"}
>>>>>>> src/components_membership_hotel/molecules/mealInputList.jsx
                                    tabIndex=""
                                />
                            } */}
                        </>
                        :
                        <>
                            <PullDownOptionForm
                                title={"会員様とのご関係"}
                                id="relation"
                                divClass="inputUserPullDownWrapLong"
                                labelClassName="popupLabel"
                                selectClass={`pullDownOptionStyle ${(flgList.errorRelation ? "errorClass" : "")} ${(inputUserInfo.applicantFlg  && !familyFlg ? "disabledClass" : "")}`}
                                data={isCrawl ? relationList : familyFlg ? relationList : inputUserInfo.applicantFlg ? relationList.filter(info => info.value == "会員本人") : relationList.filter(info => info.value != "会員本人")}
                                onChange={() => onChangeRelation()}
                                state={inputUserInfo ? inputUserInfo.relationCd : ""}
                                disabled={inputUserInfo.applicantFlg && !familyFlg}
                            />
                            <PullDownOptionForm
                                title={"利用代表者の居住地"}
                                id="prefectureCd"
                                divClass="inputUserPullDownWrapLong"
                                labelClassName="popupLabel"
                                selectClass={"pullDownOptionStyle " + (flgList.errorPrefecture ? "errorClass" : "")}
                                data={prefectureList}
                                onChange={() => onChangeInputForm("prefectureCd")}
                                state={inputUserInfo ? inputUserInfo.prefectureCd : ""}
                            />
                            <PullDownOptionForm
                                title={"交通機関"}
                                id="transport"
                                divClass="inputUserPullDownWrapLong"
                                labelClassName="popupLabel"
                                selectClass={"pullDownOptionStyle " + (flgList.errorTransport ? "errorClass" : "")}
                                data={transportList}
                                onChange={() => onChangeTransport()}
                                state={inputUserInfo ? inputUserInfo.transportCd : ""}
                            />
                            {inputUserInfo.transportCd != 2 ? null :
                                <div className='carNumForm'>
                                    <PullDownOptionForm
                                        title={"車の台数"}
                                        id="carCnt"
                                        divClass="inputUserPullDownWrapShort"
                                        labelClassName="popupLabel"
                                        selectClass={flgList.errorCarNum ? "errorPullDownOptionStyle" : "pullDownOptionStyle"}
                                        data={carNumList}
                                        onChange={() => onChangeInputForm("carCnt")}
                                        state={inputUserInfo ? inputUserInfo.carCnt : ""}
                                    />
                                    <div >
                                        <Label
                                            label="台"
                                            style={{ marginLeft: "10px" }}
                                        />
                                    </div>
                                </div>
                            }
                            {/* {inputUserInfo.transport != 3 ? null :
                                <ModalOptionForm
                                    id={"busTime"}
                                    wrapClassName={responsiveFlg ? "popupWrapLong" : "popupWrap"}
                                    labelClassName="popupLabel"
                                    title={"シャトルバス時間"}
                                    onClick={() => onClickShuttleBusTime("busTime")}
                                    text={inputUserInfo.busTime ? inputUserInfo.busTime.slice(0, 2) + ":" + inputUserInfo.busTime.slice(2) : "選択する"}
>>>>>>> src/components_membership_hotel/molecules/mealInputList.jsx
                                    tabIndex=""
                                />
                            } */}
                            {serviceCheckInfo && serviceCheckInfo.kozafurikaeKanoKbn == "1" ?
                                <>
                                    <Label
                                        label="口座振替精算"
                                        className="popupLabel"
                                    />
                                    <div className='checkboxWrapper'>
                                        <CheckboxListBoxGold
                                            id={"kozafurikaeFlg"}
                                            name={"kozafurikaeFlg"}
                                            data={[{ ...hopeCheckboxData[0], checked: inputUserInfo ? inputUserInfo.kozafurikaeFlg : false }]}
                                            onChange={() => onChangeCheckBox("kozafurikaeFlg")}
                                            tabIndex=""
                                        />
                                        <a onClick={() => onClickServiceLink("口座振替精算", serviceCheckInfo.kozafurikaeKiyakuMongon)} className="confirmContentLink">口座振替精算とは</a>
                                    </div>
                                </>
                                : null
                            }
                            {serviceCheckInfo && serviceCheckInfo.sciKanoFlg == "1" ?
                                <>  <Label
                                    label="スマートチェックイン"
                                    className="popupLabel"
                                />
                                    <div className={'checkboxWrapper ' + (flgList.errorSmartCheckIn ? "errorClass" : "")} style={inputUserInfo.nonstopCheckInFlg ? styles.disabled : {}}>
                                        <CheckboxListBoxGold
                                            id={"smartCheckInFlg"}
                                            name={"smartCheckInFlg"}
                                            data={[{ ...hopeCheckboxData[0], checked: inputUserInfo ? inputUserInfo.smartCheckInFlg : false, disabled: inputUserInfo.nonstopCheckInFlg ? true : false }]}
                                            onChange={() => onChangeCheckBox("smartCheckInFlg")}
                                            tabIndex=""
                                        />
                                        <a onClick={() => onClickServiceLink("スマートチェックイン", serviceCheckInfo.sciKiyakuMongon)} className="confirmContentLink" style={inputUserInfo.nonstopCheckInFlg ? styles.disabledBorder : {}}>スマートチェックインとは</a>
                                    </div>
                                </>
                                : null}
                            {serviceCheckInfo && serviceCheckInfo.scoKanoFlg == "1" ?
                                <>
                                    <Label
                                        label="スマートチェックアウト"
                                        className="popupLabel"
                                    />
                                    <div className='checkboxWrapper'>
                                        <CheckboxListBoxGold
                                            id={"smartCheckOutFlg"}
                                            name={"smartCheckOutFlg"}
                                            divStyle={{ fontSize: "small" }}
                                            data={[{ ...hopeCheckboxData[0], checked: inputUserInfo ? inputUserInfo.smartCheckOutFlg : false }]}
                                            onChange={() => onChangeCheckBox("smartCheckOutFlg")}
                                            tabIndex=""
                                        />
                                        <a onClick={() => onClickServiceLink("スマートチェックアウト", serviceCheckInfo.scoKiyakuMongon)} className="confirmContentLink">スマートチェックアウトとは</a>
                                    </div>
                                </>
                                : null}
                            {serviceCheckInfo && serviceCheckInfo.nonstopCheckInKanoFlg == "1" ?
                                <>
                                    <Label
                                        label="ノンストップチェックイン"
                                        className="popupLabel"
                                    />
                                    <div className={'checkboxWrapper ' + (flgList.errorNonStopCheckIn ? "errorClass" : "")} style={inputUserInfo.smartCheckInFlg ? styles.disabled : {}}>
                                        <CheckboxListBoxGold
                                            id={"nonstopCheckInFlg"}
                                            name={"nonstopCheckInFlg"}
                                            data={[{ ...nonStopCheckIn[0], checked: inputUserInfo ? inputUserInfo.nonstopCheckInFlg : false, disabled: inputUserInfo.smartCheckInFlg ? true : false }]}
                                            onChange={() => onChangeCheckBox("nonstopCheckInFlg")}
                                            tabIndex=""
                                        />
                                        <a onClick={() => onClickServiceLink("ノンストップチェックイン", serviceCheckInfo.nonstopKiyakuMongon)} className="confirmContentLink" style={inputUserInfo.smartCheckInFlg ? styles.disabledBorder : {}}>規約はこちら</a>
                                    </div>
                                </>
                                : null}
                        </>}
                    <Label
                        label="その他要望"
                        className="popupLabel"
                    />
                    <TextArea
                        id="biko"
                        value={inputUserInfo.biko}
                        onBlur={() => onChangeInputForm("biko")}
                        style={flgList.errorBiko ? styles.bikoError : styles.biko}
                        maxLength={"666"}
                    />
                    {!generalFlg && !thanksFlg && machiFlg != "2" && serviceCheckInfo && serviceCheckInfo.kenrishokaYoFlg == "1" && !isPrevKenrishokaYo ?
                        <>
                            <Label
                                label="権利消化を手動で選ぶ"
                                className="popupLabel"
                            />
                            <CheckboxListBoxGold
                                id={"selectRightFlg"}
                                name={"selectRightFlg"}
                                data={[{ ...rightDigestion[0], checked: inputUserInfo ? inputUserInfo.selectRightFlg : false }]}
                                onChange={() => onChangeCheckBox("selectRightFlg")}
                                tabIndex=""
                            />
                            <Label label="※手動で選ばない場合は自動的に最適な消化権利が選択されます（推奨）" className="annotationMessage" />
                            {
                                serviceCheckInfo && serviceCheckInfo.homeFlKanoFlg == "1" ?
                                <div id="homeFlForm" className={inputUserInfo && inputUserInfo.selectRightFlg ? "hiddenItem" : null}>
                                    <Label
                                        label="ホームフローティングの利用"
                                        className="popupLabel"
                                        style={{ marginTop: "20px" }}
                                    />
                                    <div className="annotationMessage2">ホームフローティングについては<a onClick={() => onClickOpenDescriptionHomeFlWindow()} className="annotationLink">こちら</a></div>
                                    <RadioButtonForm
                                        labelClassName="inputRadioLabel"
                                        inputClassName="inputRadioButtonGold"
                                        wrapClassName={flgList.errorUsedHomeFlKenriFlg ? "errorClassCheck" : ""}
                                        data={
                                            inputUserInfo && inputUserInfo.usedHomeFlKenriFlg
                                                ? usedHomeFlKenriList.map((usedHomeFlKenriInfo) => {
                                                    if (usedHomeFlKenriInfo.value == inputUserInfo.usedHomeFlKenriFlg) {
                                                        usedHomeFlKenriInfo.checked = true;
                                                    } else {
                                                        usedHomeFlKenriInfo.checked = false;
                                                    }
                                                    return {
                                                        text: usedHomeFlKenriInfo.text,
                                                        value: usedHomeFlKenriInfo.value,
                                                        checked: usedHomeFlKenriInfo.checked,
                                                    };
                                                })
                                                : usedHomeFlKenriList
                                        }
                                        id="usedHomeFlKenriFlg"
                                        name="usedHomeFlKenriFlg"
                                        onChange={() => {onChangeUsedHomeFlKenriFlg();}}
                                        style={{
                                            display: "flex",
                                            marginTop: "10px",
                                            marginBottom: "5px",
                                        }}
                                    />
                                    <CheckboxListBoxGold
                                        id={"saveHomeFlInfoFlg"}
                                        name={"saveHomeFlInfoFlg"}
                                        data={[{ ...saveHomeFlInfo[0], checked: inputUserInfo ? inputUserInfo.saveHomeFlInfoFlg : false }]}
                                        onChange={() => onChangeCheckBox("saveHomeFlInfoFlg")}
                                        tabIndex=""
                                        style={{
                                            marginBottom: "10px",
                                        }}
                                    />
                                    <div className='annotationMessage'>
                                        <Label
                                            label={messageConst.HOME_FL_INFO_MESSAGE}
                                        />
                                        {
                                            redFlg && !inputUserInfo.applicantFlg && usedHomeFlKenriFlg == "1" ?
                                            <Label
                                                label={messageConst.HOME_FL_INFO_RED_MESSAGE}
                                                className="redChar"
                                                id="homeFlAnnotationMessage"
                                            /> : null
                                        }
                                    </div>
                                </div> : null
                            }
                        </> : null}

                    {!generalFlg && (<>
                        <Label
                            label="予約確認メール"
                            className="popupLabel"
                        />
                        <CheckboxListBoxGold
                            id={"kakuninMailKiboKbn"}
                            name={"kakuninMailKiboKbn"}
                            data={[{ ...hopeCheckboxData[0], checked: inputUserInfo && inputUserInfo.kakuninMailKiboKbn != undefined ? inputUserInfo.kakuninMailKiboKbn : true }]}
                            wrapClassName={responsiveFlg ? "popupWrapLong" : "popupWrap"}
                            labelClassName="popupLabel"
                            onChange={() => onChangeCheckBox("kakuninMailKiboKbn")}
                            tabIndex=""
                        />
                        <Label
                            label={messageConst.RESERVE_MAIL_INFO_MESSAGE}
                            className="annotationMessage3"
                        />
                        <Label
                            label="メールアドレス"
                            className="popupLabel"
                        />
                        {reserveInfo.changeFlg ? null :
                            <CheckboxListBoxGold
                                id={"otherMailFlg"}
                                name={"otherMailFlg"}
                                data={[{ ...otherMailCheckbox[0], checked: inputUserInfo && inputUserInfo.otherMailFlg != undefined ? inputUserInfo.otherMailFlg : false }]}
                                wrapClassName={responsiveFlg ? "popupWrapLong" : "popupWrap"}
                                labelClassName="popupLabel"
                                onChange={() => onChangeCheckBox("otherMailFlg")}
                                tabIndex=""
                            />
                        }
                        <LabelInputForm
                            id="confirmReserveMail"
                            placeholder="rtg@trast.jp"
                            className={flgList.errorConfirmReserve ? "inputKeywordError" : "inputKeyword"}
                            value={inputUserInfo && reserveInfo.changeFlg || (inputUserInfo.otherMailFlg != undefined && inputUserInfo.otherMailFlg) ? inputUserInfo.confirmReserveMail : ""}
                            onChange={() => onChangeInputForm("confirmReserveMail")}
                            disabled={reserveInfo.changeFlg ? inputUserInfo.kakuninMailKiboKbn != undefined ? !inputUserInfo.kakuninMailKiboKbn : false : inputUserInfo && inputUserInfo.otherMailFlg != undefined ? !inputUserInfo.otherMailFlg : true}
                            labelClassName="popupLabel"
                            wrapClassName="userInputTextWrap3"
                            maxLength={"50"}
                        />
                    </>)}
                    {roomList?.length && (machiFlg === '1' || machiFlg === '2') ?
                        <div className='userInputTextWrap3'>
                            <Label
                                label={machiMongon}
                                className="machiPlanCheckLabel"
                            />
                            { machiMongon ?
                                <div className={flgList.errorMachiPlanCheckFlg ? "errorClassCheck" : ""}>
                                    <CheckboxListBoxGold
                                        id={"machiPlanCheckFlg"}
                                        name={"machiPlanCheckFlg"}
                                        data={[{ ...machiPlanCheck[0], checked: inputUserInfo && inputUserInfo.machiPlanCheckFlg != undefined ? inputUserInfo.machiPlanCheckFlg : false }]}
                                        wrapClassName={responsiveFlg ? "popupWrapLong" : "popupWrap"}
                                        labelClassName="popupLabel"
                                        onChange={() => onChangeCheckBox("machiPlanCheckFlg")}
                                        tabIndex=""
                                    />
                                </div>
                                : null
                            }

                        </div>
                        : null
                    }
                </div >
            </div >
        }
    </div >

    return (
        <>
            {/* <div>{otherMenu}</div> */}
            <div>{meals}</div>
            <div>{userInfo}</div>
        </>
    );
}

const styles = {
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    foodRequest: {
        resize: "none",
        width: "-webkit-fill-available",
        height: "100px",
        border: "solid 1px #b7b7b7",
        marginBottom: "60px",
    },
    foodRequestError: {
        resize: "none",
        width: "-webkit-fill-available",
        height: "100px",
        border: "solid 2px #ff0000",
        marginBottom: "60px",
        backgroundColor: "#ffdcdc",
    },
    biko: {
        resize: "none",
        width: "-webkit-fill-available",
        height: "150px",
        border: "solid 1px #b7b7b7",
    },
    bikoError: {
        resize: "none",
        width: "-webkit-fill-available",
        height: "150px",
        border: "solid 2px #ff0000",
        backgroundColor: "#ffdcdc",
    },
    priceArea: {
        display: "none",
    },
    pricePadding: {
        paddingBottom: "0",
    },
    hideRestaurantNameArea: {
        display: "none",
    },
    disabled: {
        color: "#adadad",
    },
    disabledBorder: {
        borderBottom: "1px solid #adadad",
        pointerEvents: "none",
    },
    topGrayBorder: {
        borderTop: "solid 50px gray",
    },
    label: {
        color: "black",
        fontSize: "13px"
    },
    underline: {
        paddingBottom: "0px",
        whiteSpace: "pre-line",
        color: "inherit",
        textDecoration: "none",
        borderBottom: "1px solid #696969",
        cursor: "pointer",
    },
}
